import { applySpec, complement, forEach, isNil, keys, path, pathOr, pathSatisfies } from 'ramda';
import { isNilOrEmpty } from '@@serverHelpers';
import { useGetAllOptions } from '../../hooks/useGetAllOptions';
import PricingFormulasColumnCollectiveHealth from './PricingFormulasColumnCollectiveHealth';
import { PriceBeneficiaryEnum } from '@fasstech/oip-core/entities/Price/enums';

export const PricingFormulasCollectiveHealth = ({
  prices,
  demography,
  getMiddleText,
  formulaLevelLabel,
  tariffStructureLabel,
  beneficiariesEnrollment
}) => {
  if (isNilOrEmpty(prices)) return null;

  // Extract products (tariff types with prices) and convert to detailPricing format
  const detailPricing = [];
  const optionsByName = {};

  // Process each tariff structure type
  forEach((tariffKey) => {
    const tariffData = prices[tariffKey];

    if (!isNilOrEmpty(tariffData) && tariffKey !== '__typename') {
      // Add product row if it has prices
      if (
        pathOr(null, ['yearly', 'product'], tariffData) ||
        pathOr(null, ['monthly', 'product'], tariffData)
      ) {
        detailPricing.push({
          label: pathOr(tariffKey, ['label'], tariffData),
          tariffKey: tariffKey,
          priceValue: pathOr(null, ['monthly', 'product'], tariffData),
          priceUnit: tariffData.unit
        });
      }

      // Group options by name across all tariff types
      const optionsDetail = pathOr(
        [],
        ['monthly', 'optionsDetail'],
        tariffData
      );
      if (optionsDetail.length > 0) {
        forEach((option) => {
          if (!optionsByName[option.name]) {
            optionsByName[option.name] = [];
          }
          optionsByName[option.name].push({
            tariffKey,
            tariffLabel: pathOr(tariffKey, ['label'], tariffData),
            amount: option.amount,
            unit: option.unit
          });
        }, optionsDetail);
      }
    }
  }, keys(prices));

  const allOptions = useGetAllOptions(optionsByName);

  const referenceStructure = pathSatisfies(
    complement(isNil),
    [PriceBeneficiaryEnum.EMPLOYEE],
    prices
  ) ? PriceBeneficiaryEnum.EMPLOYEE : PriceBeneficiaryEnum.FAMILY;
  const {
    totalBudgetMonthly,
    totalBudgetYearly,
    totalBudgetCompanyMonthly,
    totalBudgetCompanyYearly,
    totalBudgetUnit
  } = applySpec({
    totalBudgetMonthly: path([referenceStructure, 'totalBudgetEstimate', 'monthly']),
    totalBudgetYearly: path([referenceStructure, 'totalBudgetEstimate', 'yearly']),
    totalBudgetCompanyMonthly: path([referenceStructure, 'totalBudgetEstimateByCompany', 'monthly']),
    totalBudgetCompanyYearly: path([referenceStructure, 'totalBudgetEstimateByCompany', 'yearly']),
    totalBudgetUnit: path([referenceStructure, 'unit'])
  })(prices);

  return (
    <div className="w-full">
      <div
        className='grid gap-0 mb-2 gap-x-2'
        style={{
          gridTemplateColumns: 'repeat(3, 1fr)' //TODO : adapter nombre colonnes selon nombre formules
        }}
      >
        <PricingFormulasColumnCollectiveHealth
          columnIndex={1}
          getMiddleText={getMiddleText}
          tariffStructureLabel={tariffStructureLabel}
          detailPricing={detailPricing}
          totalBudgetYearly={totalBudgetYearly}
          totalBudgetMonthly={totalBudgetMonthly}
          totalBudgetCompanyYearly={totalBudgetCompanyYearly}
          totalBudgetCompanyMonthly={totalBudgetCompanyMonthly}
          totalBudgetUnit={totalBudgetUnit}
          demography={demography}
          allOptions={allOptions}
          formulaLevelLabel={formulaLevelLabel}
          beneficiariesEnrollment={beneficiariesEnrollment}
        />

        {/* TODO : Map on offers */}
        <PricingFormulasColumnCollectiveHealth
          columnIndex={2}
          getMiddleText={getMiddleText}
          tariffStructureLabel={tariffStructureLabel}
          detailPricing={detailPricing}
          totalBudgetYearly={totalBudgetYearly}
          totalBudgetMonthly={totalBudgetMonthly}
          totalBudgetCompanyYearly={totalBudgetCompanyYearly}
          totalBudgetCompanyMonthly={totalBudgetCompanyMonthly}
          totalBudgetUnit={totalBudgetUnit}
          demography={demography}
          allOptions={allOptions}
          formulaLevelLabel={formulaLevelLabel}
          beneficiariesEnrollment={beneficiariesEnrollment}
        />
      </div>
    </div>
  );
};
